import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const CompanyConfigValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object().shape({
    departments: yup.boolean().required(t('onboarding.companyConfig.departments.error')),
    projects: yup.boolean().required(t('onboarding.companyConfig.projects.error')),
    employees: yup.string().required(t('onboarding.companyConfig.employees.error')),
  })
}
